import { Container, Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import TextList from "components/public-dashboard/components/TextList";
import IconHeader from "components/public-dashboard/components/iconHeader";
const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function BusinessOnboardingDocHeader() {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Grid container alignItems="center" justify="center">
        <Grid item>
          <IconHeader
            title="Business Onboarding Documents"
            iconColor="#000"
            titleColor="#1CC5FF"
            titleLg="h3"
            titleSm="h4"
            titleXs="h5"
            icon={false}
            styles={{ textAlign: "center" }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
